import { required } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from 'vuex';

const normalizeCounterpartiesPayload = (data) => {
    if (Array.isArray(data)) {
        return data;
    }
    if (!data || typeof data !== 'object') {
        return [];
    }
    const models = data.models || data.data || data.items;
    return Array.isArray(models) ? models : [];
};

const buildCounterpartiesList = (data) => {
    const list = normalizeCounterpartiesPayload(data);
    if (!list.length) {
        return [];
    }
    return list.map(item => ({
        id: item.id,
        ref: item.ref,
        name: item.name,
        phone: item.phone,
        checkbox_cashiers: item.checkbox_cashiers || [],
        cashier_name: item.checkbox_cashiers && item.checkbox_cashiers.length
            ? item.checkbox_cashiers.map(c => c.full_name).join(', ')
            : null,
        is_default: item.is_default,
        after_payment_on_goods_cost: item.after_payment_on_goods_cost || false,
        _raw: item,
    }));
};

const applyCounterpartiesList = (vm, data) => {
    if (!vm) {
        return;
    }

    const list = normalizeCounterpartiesPayload(data);
    vm.toggleRenderKey = (vm.toggleRenderKey || 0) + 1;
    console.log('🔄 populateCounterpartiesList called, data:', data, 'type:', typeof data, 'isArray:', Array.isArray(data));

    vm.npCounterpartiesList = buildCounterpartiesList(list);

    if (vm.npCounterpartiesList.length) {
        vm.npCounterpartiesList.forEach(item => {
            console.log(`Counterparty ${item.name}: is_default=${item.is_default}, after_payment=${item.after_payment_on_goods_cost}`);
        });
        console.log(`✅ Populated ${vm.npCounterpartiesList.length} counterparties`);
    } else {
        console.log('ℹ️ No counterparties data or empty array');
    }

    if (typeof vm.buildDbCounterpartyOptions === 'function') {
        vm.dbCounterpartyOptions = vm.buildDbCounterpartyOptions(list);
    }
    if (typeof vm.refreshCounterpartyOptions === 'function') {
        vm.refreshCounterpartyOptions();
    }
    vm._counterpartiesLoaded = true;

    if (vm.form?.np_counterparty_sender && !vm._initializing && !vm.loadAsync && typeof vm.getSenderAddress === 'function') {
        vm.$nextTick(() => vm.getSenderAddress());
    }
};

export default {
    props: ['popupType', 'selectedItem'],
    components: {
        loader: () => import('../../../loader/loader-min.vue'),
        StatusMappingsTab: () => import('./StatusMappingsTab.vue'),
    },
    data() {
        return {
            activeTab: 'settings',
            loadAsync: false,
            syncCompleted: false,
            syncingCounterparties: false,
            showCounterpartyEdit: false,
            editingCounterparty: null,
            isAddingCounterparty: false,
            savingCounterparty: false,
            form: {
                title: '',
                description: '',
                np_title: 'Нова Пошта',
                np_logo: 'http://textilelux.lp-crm.biz/mods/nova_poshta/logo.png',
                np_module: 'nova_poshta',
                np_description: 'Курьерская служба №1 в Украине',
                np_status: 1,
                np_phone: '',
                np_firstname: '',
                np_lastname: '',
                np_middlename: '',
                np_api_key: '',
                np_area: null,
                np_city: null,
                np_warehouse: null,
                np_counterparty_sender: null,
                np_counterparty_address: null,
                np_service: 'payment_control',
            },
            list: {},
            npAreasList: [],
            npAreasListId: null,
            npCityList: [],
            npCityListId: null,
            npCityWarehouses: [],
            npCityWarehousesId: null,
            contragent: [],
            dbCounterpartyOptions: [],
            apiCounterpartyOptions: [],
            address: [],
            lastCounterpartySenderForAddress: null,
            pendingCounterpartyAddressId: null,
            pendingAddressFallback: null,
            pendingCounterpartyContact: null,
            npCounterpartiesList: [],
            cashiersList: [],
            editCityList: [],
            toggleRenderKey: 0,
            editWarehouseList: [],
            serviceOptions: [
                { id: 'payment_control', title: 'Контроль оплати' },
                { id: 'standard', title: 'Стандартна доставка' },
                { id: 'express', title: 'Експрес доставка' },
            ],
            _initializing: false,
            _counterpartiesLoaded: false,
            _areasLoaded: false,
            _optionsChecked: false,
            _loadingAddress: false,
            _updatingDefaultFromSenderSelect: false,
        };
    },

    validations: {
        form: {
            np_title: {
                required
            }
        }
    },
    computed: {
        ...mapGetters({
            options: 'config/options',
            npWarehouses: 'plugins/npWarehouses',
            warehouse: 'warehouse/warehouse',
            npAreas: 'plugins/npAreas',
            npCity: 'plugins/npCity',
            counterpartySender: 'plugins/counterpartySender',
            counterpartyAddress: 'plugins/counterpartyAddress',
            npCounterparties: 'npAutomation/npCounterparties',
            cashiersForSelect: 'checkbox/cashiersForSelect',
        }),
        counterpartiesList() {
            if (Array.isArray(this.npCounterpartiesList) && this.npCounterpartiesList.length) {
                return this.npCounterpartiesList;
            }
            return buildCounterpartiesList(this.npCounterparties);
        },
        settingsFieldsVisible() {
            if (this.syncCompleted || this.form.np_counterparty_sender || this.form.np_api_key) {
                return true;
            }
            return Array.isArray(this.counterpartiesList) && this.counterpartiesList.length > 0;
        },
        senderFullName() {
            const { np_firstname, np_lastname, np_middlename, np_phone } = this.form;
            const name = [np_lastname, np_firstname, np_middlename].filter(Boolean).join(' ');
            return name ? `${name} (${np_phone || ''})` : '';
        },
        addressPlaceholder() {
            if (!this.form.np_counterparty_sender) {
                return 'Спочатку оберіть контрагента';
            }
            if (this.address.length === 0) {
                return 'Адреси не знайдено';
            }
            if (this.addressDisplay) {
                return '';
            }
            return 'Адреса не знайдена';
        },
        addressDisplay() {
            if (!this.form?.np_counterparty_sender) {
                return '';
            }
            const selectedId = this.form.np_counterparty_address ? String(this.form.np_counterparty_address) : '';
            if (selectedId) {
                const byId = this.address.find(item => String(item.id) === selectedId);
                if (byId) {
                    return byId.title || '';
                }
                const byTitle = this.address.find(item => String(item.title) === selectedId);
                if (byTitle) {
                    return byTitle.title || '';
                }
            }
            if (this.address.length === 1) {
                return this.address[0].title || '';
            }
            const currentId = String(this.form.np_counterparty_sender);
            const currentCp = this.counterpartiesList.find(cp => String(cp.ref) === currentId || String(cp.id) === currentId);
            const fallback = this.buildFallbackAddressOption(currentCp);
            return fallback ? fallback.title : '';
        },
    },
    watch: {
        'form.np_counterparty_sender'(next, prev) {
            if (this._initializing) return;
            const nextValue = next ? String(next) : '';
            const prevValue = prev ? String(prev) : '';
            if (nextValue === prevValue) return;

            if (nextValue) {
                this.syncCompleted = true;
                this.$nextTick(() => {
                    this.setSelectedCounterpartyAsDefault(nextValue, prevValue);
                    this.getSenderAddress(nextValue);
                });
            } else {
                this.getSenderAddress(null);
            }
        },
        npAreas(e) {
            if (this._initializing) return;
            this.npAreasList = [];
            this.npCityList = [];
            this.list.np_area = null;
            this.list.np_city = null;
            this.npCityWarehouses = [];
            this.list.np_warehouse = null;
            const modelsData = e && (e.models || e.data || e);
            this.npAreasList = this.normalizeSelectOptions(modelsData);
            // Don't call checkOption here - it's already called in created() and options watcher
            // Only update areas list
        },
        npCity(e) {
            this.npCityList = [];
            this.list.np_city = null;
            this.npCityWarehouses = [];
            this.list.np_warehouse = null;
            const modelsData = e && (e.models || e.data || e);
            this.npCityList = this.normalizeSelectOptions(modelsData);
        },
        npWarehouses(e) {
            this.npCityWarehouses = [];
            this.list.np_warehouse = null;
            const modelsData = e && (e.models || e.data || e);
            this.npCityWarehouses = this.normalizeSelectOptions(modelsData);
        },
        options(e) {
            // Only check options if not already checked during initialization
            if (!this._optionsChecked && e) {
                this._optionsChecked = true;
                this.checkOption(e);
            } else if (e && !this._initializing) {
                // Allow updates after initialization
                this.checkOption(e);
            }
        },
        counterpartySender() {
            if (this._initializing) return;
            // Ignore API-provided sender list: sender must be selected from saved DB counterparties.
            this.apiCounterpartyOptions = [];
            this.refreshCounterpartyOptions();

            // Only call getSenderAddress if counterparty is set and not already loading
            if (this.form.np_counterparty_sender && !this.loadAsync) {
                this.$nextTick(() => this.getSenderAddress());
            }
        },
        counterpartyAddress(e) {
            const modelsData = e && (e.models || e.data || e);
            const normalized = this.normalizeCounterpartyAddressResponse(modelsData);

            let addresses = normalized.addresses;
            if ((!addresses || addresses.length === 0) && this.pendingAddressFallback) {
                addresses = [this.pendingAddressFallback];
            }
            this.address = addresses;

            const pending = this.pendingCounterpartyAddressId;
            if (pending && this.address.some(item => String(item.id) === String(pending))) {
                this.form.np_counterparty_address = pending;
            } else if (pending && this.pendingAddressFallback) {
                const byTitle = this.address.find(item => String(item.title) === String(this.pendingAddressFallback.title));
                if (byTitle) {
                    this.form.np_counterparty_address = byTitle.id;
                }
            } else if (this.form.np_counterparty_address && !this.address.some(item => String(item.id) === String(this.form.np_counterparty_address))) {
                this.form.np_counterparty_address = null;
            } else if (!this.form.np_counterparty_address && this.pendingAddressFallback) {
                const fallbackMatch = this.address.find(item => String(item.id) === String(this.pendingAddressFallback.id));
                if (fallbackMatch) {
                    this.form.np_counterparty_address = fallbackMatch.id;
                }
            }
            this.pendingCounterpartyAddressId = null;
            this.pendingAddressFallback = null;

            const contactSource = normalized.contact || this.pendingCounterpartyContact;
            if (contactSource) {
                this.form.np_firstname = contactSource.first_name ? contactSource.first_name : '';
                this.form.np_lastname = contactSource.last_name ? contactSource.last_name : '';
                this.form.np_middlename = contactSource.middle_name ? contactSource.middle_name : '';
                this.form.np_phone = contactSource.phone ? contactSource.phone : '';
            } else {
                this.resetSenderContactFields();
            }
            this.pendingCounterpartyContact = null;
        },
        npCounterparties: {
            handler(data) {
                console.log('🔄 npCounterparties watcher handler called, data:', data);
                if (data) {
                    applyCounterpartiesList(this, data);
                    if (this.form.np_counterparty_sender && !this._loadingAddress && (!this.address || this.address.length === 0)) {
                        this.$nextTick(() => this.getSenderAddress());
                    }
                }
            },
            immediate: true, // Fire immediately when component is created
            deep: false, // No need for deep watch since we're watching the array reference
        },
        activeTab(newTab) {
            // When switching to counterparties tab, ensure list is populated
            if (newTab === 'counterparties') {
                this.$nextTick(() => {
                    console.log('🔄 Switched to counterparties tab');
                    console.log('npCounterparties:', this.npCounterparties);
                    console.log('npCounterpartiesList length:', this.npCounterpartiesList.length);
                    
                    // Always try to populate if data exists, even if list has items (force refresh)
                    if (this.npCounterparties && Array.isArray(this.npCounterparties) && this.npCounterparties.length > 0) {
                        if (this.npCounterpartiesList.length === 0 || this.npCounterpartiesList.length !== this.npCounterparties.length) {
                            console.log('🔄 Populating counterparties list when switching to tab');
                            applyCounterpartiesList(this, this.npCounterparties);
                        } else {
                            console.log('✅ Counterparties list already populated');
                        }
                    } else {
                        console.log('⚠️ No counterparties data available');
                        // Try to reload if no data
                        if (!this._counterpartiesLoaded) {
                            console.log('🔄 Reloading counterparties...');
                            this.loadCounterparties();
                        }
                    }
                });
            } else if (newTab === 'settings') {
                // Ensure areas list is available when returning to settings tab
                if (!this.npAreasList || this.npAreasList.length === 0) {
                    this.getNpAreas()
                        .then(res => {
                            const modelsData = res?.data?.models || res?.data?.data || res?.data;
                            this.npAreasList = this.normalizeSelectOptions(modelsData);
                        })
                        .catch(() => {});
                }
            }
        },
        cashiersForSelect(data) {
            this.cashiersList = [];
            if (data) {
                for (let key in data) {
                    this.cashiersList.push({ id: parseInt(key), title: data[key] });
                }
            }
        },
    },
    created() {
        if (this._initializing) return;
        this._initializing = true;
        
        // Load areas first
        this.getNpAreas().then(() => {
            this._areasLoaded = true;
        }).catch(() => {});
        
        // Load counterparties from database
        this.loadCounterparties().then(() => {
            // Ensure watcher fires even if data was already in store
            // The watcher will handle populating npCounterpartiesList
            this.$nextTick(() => {
                // Manually trigger population if data exists but watcher didn't fire
                // This handles the case where store already had data before component mounted
                if (this.npCounterparties && Array.isArray(this.npCounterparties) && this.npCounterparties.length > 0 && this.npCounterpartiesList.length === 0) {
                    console.log('Manually populating counterparties list from store');
                    // Manually call the populate method
                    applyCounterpartiesList(this, this.npCounterparties);
                }
            });
        }).catch(() => {
            // Error already handled in loadCounterparties
        });
        
        // Load cashiers
        this.getCashiersForSelect();
        
        // Check options only once - use nextTick to ensure data is ready
        this.$nextTick(() => {
            if (!this._optionsChecked && this.options) {
                this._optionsChecked = true;
                this.checkOption(this.options);
            }
            // Reset initialization flag after a short delay to allow watchers to settle
            setTimeout(() => {
                this._initializing = false;
            }, 100);
        });
    },
    mounted() {
        // Ensure counterparties list is populated after component is mounted
        this.$nextTick(() => {
            if (this.npCounterparties && Array.isArray(this.npCounterparties) && this.npCounterparties.length > 0 && this.npCounterpartiesList.length === 0) {
                console.log('🔄 Mounted: Populating counterparties list');
                applyCounterpartiesList(this, this.npCounterparties);
            }
        });
    },
    methods: {
        getDbCounterpartyByRef(ref) {
            const normalizedRef = ref ? String(ref) : '';
            if (!this.isValidUuid(normalizedRef)) {
                return null;
            }
            const list = Array.isArray(this.counterpartiesList) ? this.counterpartiesList : [];
            return list.find(cp => String(cp.ref) === normalizedRef) || null;
        },
        setSelectedCounterpartyAsDefault(ref, prevRef) {
            if (this._updatingDefaultFromSenderSelect) {
                return;
            }
            const selected = this.getDbCounterpartyByRef(ref);
            if (!selected || !selected.id) {
                return;
            }
            if (selected.is_default === true) {
                return;
            }

            const previousDefault = this.counterpartiesList?.find(cp => cp.is_default === true) || null;
            const previousDefaultRef = previousDefault?.ref ? String(previousDefault.ref) : (prevRef ? String(prevRef) : '');

            this._updatingDefaultFromSenderSelect = true;
            this.updateNpCounterparty({
                id: selected.id,
                data: { is_default: true }
            }).then(async (res) => {
                if (res.status) {
                    this.$toasted?.success('Контрагента за замовчуванням змінено', { duration: 3000 });
                } else {
                    const errors = res.data?.errors;
                    if (errors) {
                        Object.values(errors).forEach(err => {
                            const message = Array.isArray(err) ? err[0] : err;
                            this.$toasted?.error(message, { duration: 5000 });
                        });
                    } else {
                        this.$toasted?.error(res.data?.message || 'Помилка оновлення контрагента', { duration: 5000 });
                    }
                    if (previousDefaultRef && this.isValidUuid(previousDefaultRef)) {
                        this.form.np_counterparty_sender = previousDefaultRef;
                    }
                }
                await this.getNpCounterparties();
            }).catch(() => {
                this.$toasted?.error('Помилка оновлення контрагента', { duration: 5000 });
                if (previousDefaultRef && this.isValidUuid(previousDefaultRef)) {
                    this.form.np_counterparty_sender = previousDefaultRef;
                }
                this.getNpCounterparties();
            }).finally(() => {
                this._updatingDefaultFromSenderSelect = false;
            });
        },
        normalizeSelectOptions(modelsData) {
            const options = [];
            if (!modelsData) {
                return options;
            }
            if (modelsData && typeof modelsData === 'object' && !Array.isArray(modelsData)) {
                const nested = modelsData.models || modelsData.data;
                if (nested && nested !== modelsData) {
                    return this.normalizeSelectOptions(nested);
                }
            }
            if (Array.isArray(modelsData)) {
                modelsData.forEach((item, index) => {
                    if (item === null || item === undefined) {
                        return;
                    }
                    if (typeof item === 'string' || typeof item === 'number') {
                        options.push({ id: String(item), title: String(item) });
                        return;
                    }
                    const id = item.id || item.ref || item.Ref || item.key || item.value || item.guid || item.Guid || item.GUID || String(index);
                    const title = item.title || item.name || item.Description || item.description || item.label || item.value || id;
                    options.push({ id: String(id), title: String(title) });
                });
                return options;
            }
            if (typeof modelsData === 'object') {
                Object.keys(modelsData).forEach(key => {
                    const value = modelsData[key];
                    if (value === null || value === undefined) {
                        return;
                    }
                    options.push({ id: String(key), title: String(value || key) });
                });
            }
            return options;
        },
        ensureOptionInList(list, id, title) {
            if (!id) {
                return;
            }
            const normalizedId = String(id);
            const exists = Array.isArray(list) && list.some(item => String(item.id) === normalizedId);
            if (!exists) {
                list.push({
                    id: normalizedId,
                    title: String(title || id),
                });
            }
        },
        buildDbCounterpartyOptions(data) {
            if (!Array.isArray(data)) {
                return [];
            }
            return data
                .map(item => {
                    const counterpartyId = item?.ref || item?.Ref || item?.reference || item?.Reference;
                    if (!this.isValidUuid(counterpartyId)) {
                        return null;
                    }
                    return {
                        id: String(counterpartyId),
                        title: String(item?.name || item?.title || item?.Description || `Контрагент ${item?.id || ''}`),
                    };
                })
                .filter(Boolean);
        },
        isValidUuid(value) {
            if (!value) {
                return false;
            }
            const normalized = String(value).trim();
            return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(normalized);
        },
        normalizeCounterpartyOptions(modelsData) {
            const options = [];
            if (!modelsData) {
                return options;
            }
            if (Array.isArray(modelsData)) {
                modelsData.forEach((item, index) => {
                    if (!item) {
                        return;
                    }
                    const id = item.id || item.ref || item.key || item.Ref || item.Reference || String(index);
                    const title = item.name || item.title || item.value || item.Description || item.description || id;
                    if (!this.isValidUuid(id)) {
                        return;
                    }
                    options.push({
                        id: String(id),
                        title: String(title),
                    });
                });
                return options;
            }
            if (typeof modelsData === 'object') {
                Object.keys(modelsData).forEach(key => {
                    if (!this.isValidUuid(key)) {
                        return;
                    }
                    options.push({
                        id: String(key),
                        title: String(modelsData[key] || key),
                    });
                });
            }
            return options;
        },
        normalizeCounterpartyAddressResponse(modelsData) {
            const normalized = {
                addresses: [],
                contact: null,
            };
            if (!modelsData) {
                return normalized;
            }

            const payload = modelsData && (modelsData.models || modelsData.data || modelsData);
            if (!payload) {
                return normalized;
            }

            const hasContact = payload && typeof payload === 'object' && payload.contact && typeof payload.contact === 'object';
            const contactCandidate = hasContact ? payload.contact : null;

            const addressCandidate = payload && typeof payload === 'object'
                ? (payload.address || payload.addresses || payload)
                : payload;

            const addresses = [];
            if (Array.isArray(addressCandidate)) {
                addressCandidate.forEach((item, index) => {
                    if (!item) {
                        return;
                    }
                    const id = item.id || item.ref || item.Ref || item.key || item.Reference || item.warehouse_guid || item.address || String(index);
                    const title = item.title || item.name || item.address || item.warehouse_name || item.Description || item.description || id;
                    if (!id) {
                        return;
                    }
                    if (typeof item === 'object') {
                        addresses.push({ id: String(id), title: String(title), _raw: item });
                    } else {
                        addresses.push({ id: String(id), title: String(title) });
                    }
                });
            } else if (addressCandidate && typeof addressCandidate === 'object') {
                const values = Object.values(addressCandidate);
                const isPlainMapping = values.length && values.every(value => typeof value === 'string');
                if (isPlainMapping) {
                    Object.keys(addressCandidate).forEach(key => {
                        addresses.push({ id: String(key), title: String(addressCandidate[key] || key) });
                    });
                } else if (Array.isArray(addressCandidate.data)) {
                    addressCandidate.data.forEach((item, index) => {
                        if (!item) {
                            return;
                        }
                        const id = item.id || item.ref || item.Ref || item.key || item.Reference || item.warehouse_guid || item.address || String(index);
                        const title = item.title || item.name || item.address || item.warehouse_name || item.Description || item.description || id;
                        if (!id) {
                            return;
                        }
                        if (typeof item === 'object') {
                            addresses.push({ id: String(id), title: String(title), _raw: item });
                        } else {
                            addresses.push({ id: String(id), title: String(title) });
                        }
                    });
                }
            }

            normalized.addresses = addresses;
            if (contactCandidate) {
                normalized.contact = {
                    first_name: contactCandidate.first_name || contactCandidate.firstName || '',
                    last_name: contactCandidate.last_name || contactCandidate.lastName || '',
                    middle_name: contactCandidate.middle_name || contactCandidate.middleName || '',
                    phone: contactCandidate.phone || '',
                };
            } else if (payload && typeof payload === 'object') {
                const hasInlineContact = payload.first_name || payload.last_name || payload.middle_name || payload.phone;
                if (hasInlineContact) {
                    normalized.contact = {
                        first_name: payload.first_name || '',
                        last_name: payload.last_name || '',
                        middle_name: payload.middle_name || '',
                        phone: payload.phone || '',
                    };
                }
            }
            return normalized;
        },
        buildFallbackAddressOption(counterparty) {
            const raw = counterparty?._raw || counterparty || null;
            if (!raw) {
                return null;
            }
            const title = raw.address || raw.warehouse_name || raw.city_name || raw.area_name || '';
            if (!title) {
                return null;
            }
            const id = raw.warehouse_guid || raw.address || raw.warehouse_name || raw.city_guid || raw.area_guid || raw.id || raw.ref;
            if (!id) {
                return null;
            }
            return { id: String(id), title: String(title), _raw: raw };
        },
        mergeCounterpartyOptions(primaryOptions, secondaryOptions) {
            const primary = Array.isArray(primaryOptions) ? primaryOptions : [];
            const secondary = Array.isArray(secondaryOptions) ? secondaryOptions : [];
            const byId = new Map();

            secondary.forEach(option => {
                if (!option || !option.id) {
                    return;
                }
                byId.set(String(option.id), { id: String(option.id), title: String(option.title || option.id) });
            });
            primary.forEach(option => {
                if (!option || !option.id) {
                    return;
                }
                byId.set(String(option.id), { id: String(option.id), title: String(option.title || option.id) });
            });

            return Array.from(byId.values());
        },
        applyContragentOptions(options) {
            if (!Array.isArray(options) || options.length === 0) {
                return false;
            }
            const deduped = this.mergeCounterpartyOptions(options, []);
            const cleanedOptions = deduped.filter(option => this.isValidUuid(option.id));
            if (!cleanedOptions.length) {
                return false;
            }
            this.contragent = cleanedOptions.slice().sort((a, b) => {
                if (a.title < b.title) return -1;
                if (a.title > b.title) return 1;
                return 0;
            });
            return true;
        },
        refreshCounterpartyOptions() {
            // Sender selection MUST come only from saved DB counterparties (no API-key fallback list).
            this.applyContragentOptions(this.dbCounterpartyOptions);
            this.ensureSelectedCounterparty();
        },
        ensureSelectedCounterparty() {
            if (!this.contragent.length) {
                return;
            }
            const defaultCp = Array.isArray(this.counterpartiesList)
                ? (this.counterpartiesList.find(cp => cp.is_default === true) || null)
                : null;
            const defaultRef = defaultCp?.ref ? String(defaultCp.ref) : '';
            const hasDefaultInOptions = defaultRef && this.isValidUuid(defaultRef) && this.contragent.some(item => String(item.id) === defaultRef);

            if (!this.form.np_counterparty_sender) {
                this.form.np_counterparty_sender = hasDefaultInOptions ? defaultRef : this.contragent[0].id;
                return;
            }
            const selectedId = String(this.form.np_counterparty_sender);
            if (!this.isValidUuid(selectedId)) {
                this.form.np_counterparty_sender = hasDefaultInOptions
                    ? defaultRef
                    : (this.contragent.length ? this.contragent[0].id : null);
                return;
            }
            const exists = this.contragent.some(item => String(item.id) === selectedId);
            if (!exists) {
                this.form.np_counterparty_sender = hasDefaultInOptions ? defaultRef : this.contragent[0].id;
            }
        },
        resetSenderContactFields() {
            this.form.np_firstname = '';
            this.form.np_lastname = '';
            this.form.np_middlename = '';
            this.form.np_phone = '';
        },
        npApiDataSync() {
            this.loadAsync = true;
            const payload = this.form.np_api_key ? { np_api_key: this.form.np_api_key } : {};
            this.syncNpCounterparties(payload).then(res => {
                if (res.status) {
                    this.getNpCounterparties().then(() => {
                        this.getNpAreas();
                        this.syncCompleted = true;
                        this.$nextTick(() => {
                            if (this.form.np_counterparty_sender) {
                                this.getSenderAddress();
                            }
                        });
                    });
                    const syncedCount = res.data?.models?.count || 0;
                    this.$toasted.success(`Синхронізовано: ${syncedCount} контрагентів`, { duration: 3000 });
                } else {
                    this.$toasted.error('Помилка синхронізації', { duration: 3000 });
                }
                this.loadAsync = false;
            }).catch(e => {
                console.log('Error in npApiDataSync:', e);
                console.log('Error response:', e.response?.data);
                if (e.response?.data?.errors) {
                    Object.keys(e.response.data.errors).map(item => {
                        this.$toasted.error(e.response.data.errors[item], {
                            duration: 3000,
                            position: 'top-center',
                        });
                    });
                } else {
                    this.$toasted.error('Помилка синхронізації', { duration: 3000 });
                }
                this.loadAsync = false;
            });
        },
        checkOption(res) {
            if (!res) {
                this.form = this.list;
                return;
            }
            
            // Prevent duplicate processing during initialization
            if (this._initializing && this._optionsChecked) {
                return;
            }
            
            this.form = { ...this.form, ...res.models };
            this.selectedArea();
            this.selectedCity();
            
            // If there's existing data, show the fields
            if (this.form.np_counterparty_sender || this.form.np_api_key) {
                this.syncCompleted = true;
                // Don't use global API key - only use DB counterparties
                // If counterparty is set, address will be loaded by npCounterparties watcher
            }

            // Only call getSenderAddress if counterparty is set and not during initialization
            if (this.form.np_counterparty_sender && !this._initializing && this._counterpartiesLoaded) {
                this.$nextTick(() => {
                    if (!this.loadAsync && !this._loadingAddress) {
                        this.getSenderAddress();
                    }
                });
            }
        },
        selectedArea() {
            if (!this.form.np_area) {
                this.npCityList = [];
                this.npCityWarehouses = [];
                this.form.np_city = null;
                this.form.np_warehouse = null;
                return;
            }
            this.getNpCity({ 'area_id': this.form.np_area });
        },
        selectedCity() {
            if (!this.form.np_city) {
                this.npCityWarehouses = [];
                this.form.np_warehouse = null;
                return;
            }
            this.getNpWarehouses({ 'city_id': this.form.np_city });
        },
        closePopup() {
            this.$emit('closePopup');
        },
        saveSettings() {
            // Save the selected counterparty's address and contact data
            if (!this.form.np_counterparty_sender) {
                this.$toasted.error('Спочатку оберіть контрагента', { duration: 3000 });
                return;
            }

            // Find the counterparty directly in npCounterpartiesList (database list)
            // The form.np_counterparty_sender contains the Ref (UUID)
            const dbCounterparty = this.counterpartiesList.find(cp => 
                String(cp.ref) === String(this.form.np_counterparty_sender) ||
                String(cp.id) === String(this.form.np_counterparty_sender)
            );

            if (!dbCounterparty || !dbCounterparty.id) {
                this.$toasted.error('Контрагент не збережений в базі. Спочатку додайте його через вкладку "Відправники"', { duration: 5000 });
                return;
            }

            const counterpartyId = dbCounterparty.id;

            const selectedAddress = this.address.find(item => String(item.id) === String(this.form.np_counterparty_address));
            const selectedAddressRaw = selectedAddress?._raw || null;
            const fallbackAddress = this.buildFallbackAddressOption(dbCounterparty);
            const addressValue = selectedAddress?.title
                || this.addressDisplay
                || fallbackAddress?.title
                || dbCounterparty?._raw?.address
                || null;
            const warehouseGuidFromAddress = selectedAddressRaw?.warehouse_guid || selectedAddressRaw?.warehouseGuid || fallbackAddress?._raw?.warehouse_guid || null;
            const warehouseNameFromAddress = selectedAddressRaw?.warehouse_name || selectedAddressRaw?.warehouseName || fallbackAddress?._raw?.warehouse_name || null;
            const warehouseGuid = this.form.np_warehouse || warehouseGuidFromAddress || null;
            const warehouseName = this.form.np_warehouse
                ? this.npCityWarehouses.find(w => w.id === this.form.np_warehouse)?.title || null
                : (warehouseNameFromAddress || null);

            // Prepare update data with address and contact info
            const updateData = {
                area_guid: this.form.np_area || null,
                area_name: this.npAreasList.find(a => a.id === this.form.np_area)?.title || null,
                city_guid: this.form.np_city || null,
                city_name: this.npCityList.find(c => c.id === this.form.np_city)?.title || null,
                warehouse_guid: warehouseGuid,
                warehouse_name: warehouseName,
                address: addressValue || null,
                first_name: this.form.np_firstname || null,
                middle_name: this.form.np_middlename || null,
                last_name: this.form.np_lastname || null,
                phone: this.form.np_phone || null,
            };

            this.updateNpCounterparty({
                id: counterpartyId,
                data: updateData
            }).then(res => {
                if (res.status) {
                    this.getNpCounterparties().then(() => {
                        this.$nextTick(() => this.getSenderAddress(null, { forceSavedAddress: true }));
                    });
                    this.$toasted.success('Дані контрагента збережено', { duration: 3000 });
                } else {
                    const errors = res.data?.errors;
                    if (errors) {
                        Object.values(errors).forEach(err => {
                            this.$toasted.error(Array.isArray(err) ? err[0] : err, { duration: 3000 });
                        });
                    } else {
                        this.$toasted.error('Помилка збереження', { duration: 3000 });
                    }
                }
            }).catch(() => {
                this.$toasted.error('Помилка з\'єднання з сервером', { duration: 3000 });
            });
        },
        getSenderAddress(counterpartyId, options = {}) {
            // Prevent duplicate calls
            if (this._loadingAddress) {
                return;
            }
            
            const selectedCounterpartyId = counterpartyId || this.form.np_counterparty_sender;
            if (counterpartyId && counterpartyId !== this.form.np_counterparty_sender) {
                this.form.np_counterparty_sender = counterpartyId;
            }

            if (selectedCounterpartyId) {
                if (!this.isValidUuid(selectedCounterpartyId)) {
                    this.address = [];
                    this.form.np_counterparty_address = null;
                    this.resetSenderContactFields();
                    this.$toasted.error('Некоректний ID контрагента. Синхронізуйте або виправте Ref.', { duration: 3000 });
                    return;
                }
                const currentCounterpartyId = String(selectedCounterpartyId);
                const forceSavedAddress = options && options.forceSavedAddress === true;
                const previousCounterpartyId = this.lastCounterpartySenderForAddress ? String(this.lastCounterpartySenderForAddress) : null;
                const counterpartyChanged = previousCounterpartyId !== null && previousCounterpartyId !== currentCounterpartyId;
                if (counterpartyChanged) {
                    this.form.np_counterparty_address = null;
                    this.pendingCounterpartyAddressId = null;
                    this.pendingAddressFallback = null;
                    this.address = [];
                } else {
                    this.pendingCounterpartyAddressId = this.form.np_counterparty_address;
                }

                this.lastCounterpartySenderForAddress = currentCounterpartyId;
                this.resetSenderContactFields();

                // Find counterparty in npCounterpartiesList to get DB id
                const dbCounterparty = this.counterpartiesList.find(cp => cp.ref === currentCounterpartyId || String(cp.id) === currentCounterpartyId);
                const dbCounterpartyId = dbCounterparty?.id || dbCounterparty?._raw?.id;
                const savedAddressId = dbCounterparty?._raw?.warehouse_guid || dbCounterparty?._raw?.address || null;
                if (forceSavedAddress) {
                    this.form.np_counterparty_address = null;
                    this.pendingCounterpartyAddressId = savedAddressId ? String(savedAddressId) : null;
                } else if (savedAddressId && !this.pendingCounterpartyAddressId) {
                    this.pendingCounterpartyAddressId = String(savedAddressId);
                }
                this.pendingAddressFallback = this.buildFallbackAddressOption(dbCounterparty);
                if (!this.pendingCounterpartyAddressId && this.pendingAddressFallback) {
                    this.pendingCounterpartyAddressId = this.pendingAddressFallback.id;
                }
                if (this.pendingAddressFallback) {
                    this.address = [this.pendingAddressFallback];
                    if (this.pendingCounterpartyAddressId === this.pendingAddressFallback.id) {
                        this.form.np_counterparty_address = this.pendingCounterpartyAddressId;
                    }
                } else {
                    this.address = [];
                }
                if (dbCounterparty?._raw) {
                    this.pendingCounterpartyContact = {
                        first_name: dbCounterparty._raw.first_name || dbCounterparty._raw.firstName || '',
                        last_name: dbCounterparty._raw.last_name || dbCounterparty._raw.lastName || '',
                        middle_name: dbCounterparty._raw.middle_name || dbCounterparty._raw.middleName || '',
                        phone: dbCounterparty._raw.phone || '',
                    };
                    // Immediately populate contact fields from DB data (set to empty string if null/undefined)
                    this.form.np_firstname = this.pendingCounterpartyContact.first_name || '';
                    this.form.np_lastname = this.pendingCounterpartyContact.last_name || '';
                    this.form.np_middlename = this.pendingCounterpartyContact.middle_name || '';
                    this.form.np_phone = this.pendingCounterpartyContact.phone || '';
                    
                    // Populate address fields from counterparty's saved data
                    if (dbCounterparty._raw.area_guid) {
                        this.form.np_area = dbCounterparty._raw.area_guid;
                        this.ensureOptionInList(this.npAreasList, dbCounterparty._raw.area_guid, dbCounterparty._raw.area_name);
                        
                        // Load cities for this area
                        this.getNpCity({ area_id: dbCounterparty._raw.area_guid }).then(() => {
                            if (dbCounterparty._raw.city_guid) {
                                this.form.np_city = dbCounterparty._raw.city_guid;
                                this.ensureOptionInList(this.npCityList, dbCounterparty._raw.city_guid, dbCounterparty._raw.city_name);
                                
                                // Load warehouses for this city
                                this.getNpWarehouses({ city_id: dbCounterparty._raw.city_guid }).then(() => {
                                    if (dbCounterparty._raw.warehouse_guid) {
                                        this.form.np_warehouse = dbCounterparty._raw.warehouse_guid;
                                        this.ensureOptionInList(this.npCityWarehouses, dbCounterparty._raw.warehouse_guid, dbCounterparty._raw.warehouse_name);
                                    } else {
                                        // Clear warehouse if not saved
                                        this.form.np_warehouse = null;
                                    }
                                }).catch(e => {
                                    console.log('Error loading warehouses:', e);
                                });
                            } else {
                                // Clear city and warehouse if not saved
                                this.form.np_city = null;
                                this.form.np_warehouse = null;
                                this.npCityList = [];
                                this.npCityWarehouses = [];
                            }
                        }).catch(e => {
                            console.log('Error loading cities:', e);
                        });
                    } else {
                        // Clear all address fields if area not saved
                        this.form.np_area = null;
                        this.form.np_city = null;
                        this.form.np_warehouse = null;
                        this.npCityList = [];
                        this.npCityWarehouses = [];
                    }
                } else {
                    // No saved data - clear/reset all fields
                    this.pendingCounterpartyContact = null;
                    this.form.np_firstname = '';
                    this.form.np_lastname = '';
                    this.form.np_middlename = '';
                    this.form.np_phone = '';
                    this.form.np_area = null;
                    this.form.np_city = null;
                    this.form.np_warehouse = null;
                    this.npCityList = [];
                    this.npCityWarehouses = [];
                }

                // Build payload - pass both NP ref (counterparty_id) and DB id (db_counterparty_id) so backend uses counterparty's own stored np_api_key
                let payload = { counterparty_id: currentCounterpartyId };
                if (dbCounterpartyId) {
                    // For DB counterparties - pass DB id, backend will use counterparty's own stored API key
                    payload.db_counterparty_id = dbCounterpartyId;
                    this._loadingAddress = true;
                    const fallbackAddress = this.pendingAddressFallback;
                    
                    // Load addresses for selected counterparty
                    this.getCounterpartyAddress(payload).then(res => {
                        // Addresses will be populated by the counterpartyAddress watcher
                        if (!res || !res.status) {
                            if (fallbackAddress) {
                                this.address = [fallbackAddress];
                            } else {
                                // If loading failed, ensure address array is empty
                                this.address = [];
                                this.form.np_counterparty_address = null;
                                this.resetSenderContactFields();
                            }
                        }
                    }).catch(e => {
                        // Handle error silently - address array will remain empty
                        console.log('Error loading addresses:', e);
                        if (fallbackAddress) {
                            this.address = [fallbackAddress];
                        } else {
                            this.address = [];
                            this.form.np_counterparty_address = null;
                            this.resetSenderContactFields();
                        }
                    }).finally(() => {
                        this._loadingAddress = false;
                    });
                } else {
                    // Require database counterparty - no fallback to global API key
                    this._loadingAddress = false;
                    const errorMsg = 'Виберіть контрагента з бази даних або додайте його через налаштування Нової Пошти';
                    if (this.$toasted) {
                        this.$toasted.error(errorMsg, { duration: 5000 });
                    }
                    console.error('Counterparty not found in database:', currentCounterpartyId);
                    if (this.pendingAddressFallback) {
                        this.address = [this.pendingAddressFallback];
                    } else {
                        this.address = [];
                        this.form.np_counterparty_address = null;
                        this.resetSenderContactFields();
                    }
                }
            } else {
                // Clear addresses if no counterparty
                this.address = [];
                this.form.np_counterparty_address = null;
                this.lastCounterpartySenderForAddress = null;
                this.pendingCounterpartyAddressId = null;
                this.pendingAddressFallback = null;
                this.pendingCounterpartyContact = null;
                this.resetSenderContactFields();
            }
        },
        
        // Counterparties methods
        populateCounterpartiesList(data) {
            applyCounterpartiesList(this, data);
        },
        loadCounterparties() {
            // Only load counterparties from database - no API fallback
            return this.getNpCounterparties()
                .then((res) => {
                    // Response is handled by the npCounterparties watcher
                    // which will populate npCounterpartiesList and set _counterpartiesLoaded
                    if (res && res.status) {
                        // Data is already committed to store by the action
                        // Force watcher to fire by ensuring reactivity
                        this.$nextTick(() => {
                            // Double-check that list is populated
                            if (this.npCounterparties && Array.isArray(this.npCounterparties) && this.npCounterparties.length > 0) {
                                if (this.npCounterpartiesList.length === 0) {
                                    console.log('Force populating counterparties list after load');
                                    applyCounterpartiesList(this, this.npCounterparties);
                                }
                            }
                        });
                        console.log('Counterparties loaded successfully');
                    } else {
                        // No counterparties in database - this is OK, user can sync or add
                        console.log('No counterparties found in database');
                        this._counterpartiesLoaded = true;
                    }
                    return res;
                })
                .catch((error) => {
                    // Error loading counterparties - user must add them to database
                    console.error('Failed to load counterparties from database:', error);
                    this._counterpartiesLoaded = true; // Set flag even on error to allow UI to work
                    // Show user-friendly message only if list is truly empty
                    if (this.$toasted && (!this.npCounterparties || this.npCounterparties.length === 0)) {
                        this.$toasted.info('Немає контрагентів у базі даних. Ви можете синхронізувати їх з Нової Пошти або додати вручну.', { duration: 5000 });
                    }
                    throw error; // Re-throw to allow caller to handle
                });
        },
        syncCounterparties() {
            this.syncingCounterparties = true;
            const payload = this.form.np_api_key ? { np_api_key: this.form.np_api_key } : {};
            this.syncNpCounterparties(payload).then(res => {
                this.syncingCounterparties = false;
                if (res.status) {
                    this.getNpCounterparties().then(() => {
                        if (this.form.np_counterparty_sender) {
                            this.getSenderAddress();
                        }
                    });
                    this.$toasted.success(`Синхронізовано: ${res.data?.models?.count || 0} контрагентів`, { duration: 3000 });
                } else {
                    this.$toasted.error('Помилка синхронізації', { duration: 3000 });
                }
            }).catch(() => {
                this.syncingCounterparties = false;
                this.$toasted.error('Помилка синхронізації', { duration: 3000 });
            });
        },
        openAddCounterparty() {
            this.isAddingCounterparty = true;
            this.editingCounterparty = {
                name: '',
                np_api_key: '',
                is_default: false,
                after_payment_on_goods_cost: false,
            };
            this.showCounterpartyEdit = true;
        },
        editCounterparty(cp) {
            this.isAddingCounterparty = false;
            
            // Include checkbox_cashiers and address fields from _raw if available
            this.editingCounterparty = {
                ...cp,
                // Extract address fields from _raw
                area_guid: cp._raw?.area_guid || cp.area_guid || null,
                area_name: cp._raw?.area_name || cp.area_name || null,
                city_guid: cp._raw?.city_guid || cp.city_guid || null,
                city_name: cp._raw?.city_name || cp.city_name || null,
                warehouse_guid: cp._raw?.warehouse_guid || cp.warehouse_guid || null,
                warehouse_name: cp._raw?.warehouse_name || cp.warehouse_name || null,
                first_name: cp._raw?.first_name || cp.first_name || null,
                middle_name: cp._raw?.middle_name || cp.middle_name || null,
                last_name: cp._raw?.last_name || cp.last_name || null,
                checkbox_cashiers: cp._raw?.checkbox_cashiers || cp.checkbox_cashiers || [],
                after_payment_on_goods_cost: cp._raw?.after_payment_on_goods_cost || cp.after_payment_on_goods_cost || false,
            };
            console.log('npAreasList length:', this.npAreasList.length);
            console.log('npAreasList:', this.npAreasList);
            
            // Initialize lists with existing values so dropdowns aren't disabled
            this.editCityList = [];
            this.editWarehouseList = [];
            
            // Pre-populate lists with saved values to prevent disabled dropdowns
            if (this.editingCounterparty.city_guid && this.editingCounterparty.city_name) {
                this.editCityList = [{
                    id: this.editingCounterparty.city_guid,
                    title: this.editingCounterparty.city_name
                }];
            }
            if (this.editingCounterparty.warehouse_guid && this.editingCounterparty.warehouse_name) {
                this.editWarehouseList = [{
                    id: this.editingCounterparty.warehouse_guid,
                    title: this.editingCounterparty.warehouse_name
                }];
            }
            
            this.showCounterpartyEdit = true;
            this.ensureOptionInList(this.npAreasList, this.editingCounterparty.area_guid, this.editingCounterparty.area_name);

            // Refresh areas list and load dependent lists for current counterparty
            this.getNpAreas()
                .then(() => {
                    this.ensureOptionInList(this.npAreasList, this.editingCounterparty.area_guid, this.editingCounterparty.area_name);
                })
                .catch(() => {});
            if (this.editingCounterparty.area_guid) {
                this.loadEditCities(this.editingCounterparty.area_guid).then(() => {
                    if (this.editingCounterparty.city_guid) {
                        this.loadEditWarehouses(this.editingCounterparty.city_guid);
                    }
                });
            }
        },
        async loadEditCities(areaGuid) {
            try {
                // Preserve currently selected city during API call
                const currentSelection = this.editingCounterparty?.city_guid && this.editingCounterparty?.city_name ? {
                    id: this.editingCounterparty.city_guid,
                    title: this.editingCounterparty.city_name
                } : null;
                
                const res = await this.getNpCity({ area_id: areaGuid });
                const modelsData = res?.data?.models || res?.data?.data || res?.data;
                this.editCityList = this.normalizeSelectOptions(modelsData);
                
                // Ensure selected option is in the list
                if (currentSelection) {
                    this.ensureOptionInList(this.editCityList, currentSelection.id, currentSelection.title);
                }
            } catch (e) {
                console.log('Error loading cities:', e);
                // On error, ensure the current selection remains visible
                if (this.editingCounterparty?.city_guid && this.editingCounterparty?.city_name) {
                    this.editCityList = [{
                        id: this.editingCounterparty.city_guid,
                        title: this.editingCounterparty.city_name
                    }];
                }
            }
        },
        async loadEditWarehouses(cityGuid) {
            try {
                // Preserve currently selected warehouse during API call
                const currentSelection = this.editingCounterparty?.warehouse_guid && this.editingCounterparty?.warehouse_name ? {
                    id: this.editingCounterparty.warehouse_guid,
                    title: this.editingCounterparty.warehouse_name
                } : null;
                
                const res = await this.getNpWarehouses({ city_id: cityGuid });
                const modelsData = res?.data?.models || res?.data?.data || res?.data;
                this.editWarehouseList = this.normalizeSelectOptions(modelsData);
                
                // Ensure selected option is in the list
                if (currentSelection) {
                    this.ensureOptionInList(this.editWarehouseList, currentSelection.id, currentSelection.title);
                }
            } catch (e) {
                console.log('Error loading warehouses:', e);
                // On error, ensure the current selection remains visible
                if (this.editingCounterparty?.warehouse_guid && this.editingCounterparty?.warehouse_name) {
                    this.editWarehouseList = [{
                        id: this.editingCounterparty.warehouse_guid,
                        title: this.editingCounterparty.warehouse_name
                    }];
                }
            }
        },
        onEditAreaChange(areaGuid) {
            // Reset city and warehouse when area changes
            this.editingCounterparty.city_guid = null;
            this.editingCounterparty.warehouse_guid = null;
            this.editCityList = [];
            this.editWarehouseList = [];

            // Find area name
            const area = this.npAreasList.find(a => a.id === areaGuid);
            this.editingCounterparty.area_name = area ? area.title : null;

            if (areaGuid) {
                this.loadEditCities(areaGuid);
            }
        },
        onEditCityChange(cityGuid) {
            // Reset warehouse when city changes
            this.editingCounterparty.warehouse_guid = null;
            this.editWarehouseList = [];

            // Find city name
            const city = this.editCityList.find(c => c.id === cityGuid);
            this.editingCounterparty.city_name = city ? city.title : null;

            if (cityGuid) {
                this.loadEditWarehouses(cityGuid);
            }
        },
        closeCounterpartyModal() {
            this.showCounterpartyEdit = false;
            this.editingCounterparty = null;
            this.isAddingCounterparty = false;
        },
        saveCounterparty() {
            this.savingCounterparty = true;
            
            if (this.isAddingCounterparty) {
                // Add new counterparty - use np_api_key, rest will be synced from API
                const payload = {
                    name: this.editingCounterparty.name || 'Контрагент (очікує синхронізації)',
                    np_api_key: this.editingCounterparty.np_api_key,
                    is_default: this.editingCounterparty.is_default,
                    after_payment_on_goods_cost: this.editingCounterparty.after_payment_on_goods_cost,
                };
                
                this.createNpCounterparty(payload).then(res => {
                    this.savingCounterparty = false;
                    if (res.status) {
                        this.getNpCounterparties().then(() => {
                            if (this.form.np_counterparty_sender) {
                                this.getSenderAddress();
                            }
                        });
                        this.$toasted.success('Контрагента додано', { duration: 3000 });
                        this.closeCounterpartyModal();
                    } else {
                        const errors = res.data?.errors;
                        if (errors) {
                            Object.values(errors).forEach(err => {
                                this.$toasted.error(Array.isArray(err) ? err[0] : err, { duration: 3000 });
                            });
                        } else {
                            this.$toasted.error('Помилка додавання', { duration: 3000 });
                        }
                    }
                }).catch(() => {
                    this.savingCounterparty = false;
                    this.$toasted.error('Помилка додавання', { duration: 3000 });
                });
            } else {
                // Update existing counterparty with address fields
                // Find warehouse name from list
                const warehouse = this.editWarehouseList.find(w => w.id === this.editingCounterparty.warehouse_guid);
                const warehouseName = warehouse ? warehouse.title : this.editingCounterparty.warehouse_name;

                // Build address string from city + warehouse
                const cityName = this.editingCounterparty.city_name || '';
                const address = [cityName, warehouseName].filter(Boolean).join(', ');

                const updateData = {
                    ref: this.editingCounterparty.ref,
                    is_default: this.editingCounterparty.is_default,
                    after_payment_on_goods_cost: this.editingCounterparty.after_payment_on_goods_cost,
                    // Address fields for manual entry
                    area_guid: this.editingCounterparty.area_guid || null,
                    area_name: this.editingCounterparty.area_name || null,
                    city_guid: this.editingCounterparty.city_guid || null,
                    city_name: this.editingCounterparty.city_name || null,
                    warehouse_guid: this.editingCounterparty.warehouse_guid || null,
                    warehouse_name: warehouseName || null,
                    address: address || null,
                };

                this.updateNpCounterparty({
                    id: this.editingCounterparty.id,
                    data: updateData
                }).then(res => {
                    this.savingCounterparty = false;
                    if (res.status) {
                        this.getNpCounterparties().then(() => {
                            if (this.form.np_counterparty_sender) {
                                this.getSenderAddress();
                            }
                        });
                        this.$toasted.success('Контрагента оновлено', { duration: 3000 });
                        this.closeCounterpartyModal();
                    } else {
                        this.$toasted.error('Помилка збереження', { duration: 3000 });
                    }
                }).catch(() => {
                    this.savingCounterparty = false;
                    this.$toasted.error('Помилка збереження', { duration: 3000 });
                });
            }
        },
        deleteCounterparty(cp) {
            if (confirm(`Видалити контрагента "${cp.name}"?`)) {
                this.removeNpCounterparty(cp.id).then(res => {
                    if (res.status) {
                        this.getNpCounterparties();
                        this.$toasted.success('Контрагента видалено', { duration: 3000 });
                    } else {
                        this.$toasted.error('Помилка видалення', { duration: 3000 });
                    }
                });
            }
        },
        setDefaultCounterparty(cp) {
            const originalValue = cp.is_default;
            const newValue = !originalValue;

            // Make API request
            this.updateNpCounterparty({ 
                id: cp.id, 
                data: { is_default: newValue }
            }).then(res => {
                if (res.status) {
                    // Success: reload the list to get correct state from backend
                    this.getNpCounterparties();
                    this.$toasted.success('Контрагента оновлено', { duration: 3000 });
                } else {
                    // Error: reload the list to reset all states to backend values
                    this.getNpCounterparties();
                    
                    const errors = res.data?.errors;
                    if (errors) {
                        Object.values(errors).forEach(err => {
                            const message = Array.isArray(err) ? err[0] : err;
                            this.$toasted.error(message, { duration: 5000 });
                        });
                    } else {
                        const message = res.data?.message || 'Помилка оновлення контрагента';
                        this.$toasted.error(message, { duration: 5000 });
                    }
                }
            }).catch(() => {
                // Network error: reload the list to reset all states
                this.getNpCounterparties();
                this.$toasted.error('Помилка з\'єднання з сервером', { duration: 5000 });
            });
        },
        setPaymentControl(cp) {
            const originalValue = cp.after_payment_on_goods_cost;
            const newValue = !originalValue;

            // Make API request
            this.updateNpCounterparty({ 
                id: cp.id, 
                data: { after_payment_on_goods_cost: newValue }
            }).then(res => {
                if (res.status) {
                    // Success: reload the list to get correct state from backend
                    this.getNpCounterparties();
                    this.$toasted.success('Контроль оплати оновлено', { duration: 3000 });
                } else {
                    // Error: reload the list to reset all states to backend values
                    this.getNpCounterparties();
                    
                    const errors = res.data?.errors;
                    if (errors) {
                        Object.values(errors).forEach(err => {
                            const message = Array.isArray(err) ? err[0] : err;
                            this.$toasted.error(message, { duration: 5000 });
                        });
                    } else {
                        const message = res.data?.message || 'Помилка оновлення контролю оплати';
                        this.$toasted.error(message, { duration: 5000 });
                    }
                }
            }).catch(() => {
                // Network error: reload the list to reset all states
                this.getNpCounterparties();
                this.$toasted.error('Помилка з\'єднання з сервером', { duration: 5000 });
            });
        },
        syncSingleCounterparty(cp) {
            // Check if counterparty has stored API key (we don't see it, but backend knows)
            // Show warning that sync uses stored key
            if (!cp._raw?.id) {
                this.$toasted.warning('Неможливо синхронізувати: контрагент не збережений', { duration: 3000 });
                return;
            }

            this.$set(cp, '_syncing', true);
            this.syncNpCounterparty(cp.id).then(res => {
                this.$set(cp, '_syncing', false);
                if (res.status) {
                    this.getNpCounterparties();
                    this.$toasted.success('Контрагента синхронізовано', { duration: 3000 });
                } else {
                    const errorMsg = res.data?.message || res.data?.error || 'Помилка синхронізації. Можливо, API ключ не збережено для цього контрагента.';
                    this.$toasted.warning(errorMsg, { duration: 4000 });
                }
            }).catch(() => {
                this.$set(cp, '_syncing', false);
                this.$toasted.error('Помилка синхронізації', { duration: 3000 });
            });
        },

        ...mapActions({
            getNpAreas: 'plugins/getNpAreas',
            getNpCity: 'plugins/getNpCity',
            getNpWarehouses: 'plugins/getNpWarehouses',
            getCounterpartySender: 'plugins/getCounterpartySender',
            getCounterpartyAddress: 'plugins/getCounterpartyAddress',
            getNpCounterparties: 'npAutomation/getNpCounterparties',
            createNpCounterparty: 'npAutomation/createNpCounterparty',
            updateNpCounterparty: 'npAutomation/updateNpCounterparty',
            removeNpCounterparty: 'npAutomation/removeNpCounterparty',
            syncNpCounterparties: 'npAutomation/syncNpCounterparties',
            syncNpCounterparty: 'npAutomation/syncNpCounterparty',
            getCashiersForSelect: 'checkbox/getCashiersForSelect',
        }),
        ...mapMutations({
            changeShowWarehouse: 'warehouse/changeShowWarehouse'
        })
    },
    destroyed() {
        this.changeShowWarehouse(null);
    }
};
